export const WEB_TEXT_COMMON = {
  LOGOUT: "Đăng xuất",
};

export const WEB_TEXT_HOME = {
  SEND_OTP: "Gửi mã",
  REGISTER_ACCOUNT: "Đăng ký tài khoản",
  PHONE_NUMBER: "Số điện thoại",
  ENTER_PHONE_NUMBER: "Nhập số điện thoại...",
  OTP_CODE: "Mã OTP",
  ENTER_OTP_CODE: "Nhập mã OTP...",
  INCORRECT_OTP_CODE: "Mã OTP không đúng hoặc đã hết hạn",
  OTP_HAS_BEEN_SENT: "Mã OTP đã được gửi đến số điện thoại bạn vừa nhập.",
  REGISTER: "Đăng ký",
};

export const WEB_TEXT_UPDATE_USER_INFO = {
  TITLE: "Cập nhật thông tin cá nhân",
  CUSTOMER_CODE: "Mã khách hàng",
  PHONE_NUMBER: "Số điện thoại",
  ENTER_CUSTOMER_CODE: "Nhập mã khách hàng...",
  ENTER_PHONE_NUMBER: "Nhập số điện thoại...",
  NAME: "Họ và tên",
  ENTER_NAME: "Nhập họ và tên...",
  EMAIL: "Email",
  ENTER_EMAIL: "Nhập email...",
  SEND_OTP: "Gửi mã",
  VALIDATION: "Xác thực",
  INVALID_EMAIL: "Email không đúng định dạng! Vui lòng thử lại",
  VALID_EMAIL: "Email này được sử dụng để tạo lại mật khẩu khi quên mật khẩu",
  OTP_CODE: "Mã OTP",
  ENTER_OTP_CODE: "Nhập mã OTP...",
  INCORRECT_OTP: "Mã OTP không đúng hoặc đã hết hạn",
  BIRTH_DAY: "Ngày sinh",
  GENDER: "Giới tính",
  SELECT: "Chọn...",
  ADDRESS: "Địa chỉ",
  ENTER_ADDRESS: "Nhập địa chỉ...",
  PASSWORD: "Mật khẩu",
  ENTER_PASSWORD: "Nhập mật khẩu...",
  PASSWORD_LENGTH_1: "Có độ dài từ 8 đến 20 kí tự",
  PASSWORD_LENGTH_2: "Bao gồm chữ cái viết thường và viết hoa",
  RE_PASSWORD: "Nhập lại mật khẩu",
  ENTER_RE_PASSWORD: "Nhập lại mật khẩu...",
  MISMATCH_PASSWORD: "Mật khẩu không khớp nhau!",
  CONSENT_1: "Tôi đã đọc và đồng ý với",
  CONSENT_2: "Thể lệ của chương trình",
  CONFIRM_INFO: "Xác nhận thông tin",
  MALE: "Nam",
  FE_MALE: "Nữ",
  OTHER: "Khác",
};

export const WEB_TEXT_USER_INFO = {
  TITLE: "Thông tin khách hàng",
  PAGE_NAME: "Thông tin cá nhân",
  CHANGE_PASSWORD: "Đổi mật khẩu",
  EDIT: "Chỉnh sửa",
  COMPLETE: "Hoàn tất",
  OTHER_INFORMATION: "Thông tin khác",
};

export const WEB_TEXT_GIFT_LIST = {
  PAGE_NAME: "Danh sách quà",
  REDEEM: "Đổi quà",
};
export const WEB_TEXT_GIFT_DETAIL = {
  PAGE_NAME: "Chi tiết quà tặng",
  TRUE_POINT_NUMBER: "Số true POINT",
  TRUE_POINT: "true POINT",
  QUANTITY: "Số lượng",
  NOTE: "*Lưu ý: Bạn vui lòng ghé cửa hàng để nhận quà sau 10 ngày.",
  CAMPAIGN_DETAIL: "Chi tiết chương trình",
  LIST_STORE: "Danh sách cửa hàng cho phép đổi quà",
  TOTAL: "Tổng",
  REDEEM: "Đổi quà",
};
export const WEB_TEXT_MY_GIFTS = {};
export const WEB_TEXT_MY_GIFT_DETAIL = {};
